// libs
import React, { memo } from 'react';

// styles
import { Image } from './styles';

// context
import { useDomainConfig } from 'shared/domainConfig/context/context';

// constants
import { LOGO_TYPE } from 'shared/constants';

// defs
interface ILogoProps {
  className?: string;
  type: string;
  pdpSearchBarEnabled?: boolean;
}

function Logo({ className, type, pdpSearchBarEnabled }: ILogoProps) {
  const { LOGO, SMALL_LOGO } = useDomainConfig();
  let logo = LOGO;
  if (pdpSearchBarEnabled && type === LOGO_TYPE.MWEB) {
    logo = SMALL_LOGO;
  }

  const { WIDTH, HEIGHT, URL } = logo[type] || {};
  const { LOGO_ALT_TEXT } = logo;

  return (
    <Image width={WIDTH} height={HEIGHT} src={URL} className={className} alt={LOGO_ALT_TEXT} />
  );
}

export default memo(Logo);
